import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, mergeProps as _mergeProps, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-73350c3c"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("导出")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("成本修改")
const _hoisted_3 = { class: "d-flex align-items-center" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "单位社保", -1))

import { ref, onBeforeMount } from 'vue'
import tbMix, {cpyCfig, orgCfig} from '@/global_mixin/tableMixin'
import { exportHandle, formatNumber } from '@/utils/index'
import { ElMessage } from 'element-plus'
import salaryTemp from '@/views/ViewsComponents/salary/salaryTemplate.vue'
import Api from '@/http/modules/index'
import store from '@/store/index'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const {
  'POST/users/salary_details/page/finance': fetchList,
  // 导出成本列表
  'POST/users/salary_details/export': exportCostApi,
  // 获取财务岗位下拉
  'GET/user_finances': financialJobListApi,
} = Api

const { MI_modifyForm } = new tbMix(() => Promise.resolve())

let financialJobList: any = ref([])

onBeforeMount(()=> {
  financialJobListApi().then((rep: any) => {
    financialJobList.value = rep.concat([{name: 'null', id: 'null'}])
  })
})
// search config
const companySocialFg = ref<boolean>(false)
const searchConfig = ref([
  {
    label: '姓名',
    value: '',
    upKey: 'name'
  },
  {
    type: "TIME",
    label: "时间",
    value: '',
    upKey: 'financeMonth',
    props: { 'value-format': 'YYYY-MM', type: 'month', clearable: true}
  },
  {
    type: 'SELECT',
    label: '财务岗位',
    value: '',
    upKey: 'position',
    options: financialJobList,
    seleProps: { label: 'name', valueName: 'id', },
    props: { placeholder: '请选择财务岗位', clearable: true }
  },
  orgCfig(),
  // cpyCfig(),
  {
    type: "SELECT",
    selectType: 'GROUP',
    label: "公司",
    value: "",
    upKey: "companyId",
    options: store.getters.sysCompany,
    props: {clearable: true, placeholder: "请选择公司"},
    seleProps: { label: "name", valueName: "id" },
  },
])


// 导出成本列表
const exportCostFg = ref<boolean>(false)
const exportCostHandle = async (params: object) => {
  ElMessage('开始下载')
  try {
    let stream: any = await exportCostApi(params, {timeout: 60000, responseType: 'blob'})
    let fileName = decodeURI(stream.headers['content-disposition'].split(';')[1].split('filename=')[1])
    let url = window.URL.createObjectURL(
      new Blob([stream.data], { type: 'application/vnd.ms-excel;charset=utf-8' })
    )

    let link = document.createElement("a")
    link.style.display = "none"
    link.href = url
    link.setAttribute(
      "download",
      decodeURI(fileName)
    )
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    ElMessage.success('下载成功')
    exportCostFg.value = false
  } catch (error) {
    exportCostFg.value = false
    console.log(error);
    ElMessage.error('下载失败')
  }
}
const showExportCostHandle = () => {
  MI_modifyForm({}, searchConfig, exportCostFg, async (params: any) => {
    await exportHandle(exportCostApi, params)
    ElMessage.success('成功')
    exportCostFg.value = false
  })
}

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_expand = _resolveComponent("expand")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_FlexibleForm = _resolveComponent("FlexibleForm")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(salaryTemp, {
      basicParams: {},
      basicSearchConfig: searchConfig.value,
      showPersonalColumn: false,
      basicApi: _unref(fetchList)
    }, {
      buttonArea: _withCtx(() => [
        _createVNode(_component_el_button, {
          class: "mt-10",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (showExportCostHandle()))
        }, {
          default: _withCtx(() => [
            _hoisted_1
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          class: "mt-10",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push({ name: 'salaryModify'})))
        }, {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        })
      ]),
      columnHead: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          label: "姓名",
          prop: "userName",
          fixed: ""
        }),
        _createVNode(_component_el_table_column, {
          label: "英文名",
          prop: "alias",
          width: "100",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "公司",
          prop: "companyName",
          width: "200",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "团队",
          prop: "orgName",
          width: "100"
        }),
        _createVNode(_component_el_table_column, {
          label: "财务岗位",
          prop: "position",
          width: "100"
        })
      ]),
      columnEnd: _withCtx(() => [
        _createVNode(_component_el_table_column, { label: "单位社保" }, {
          header: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              _hoisted_4,
              _createVNode(_component_el_icon, {
                class: "column-icon",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (companySocialFg.value  = !companySocialFg.value))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_expand)
                ]),
                _: 1
              })
            ])
          ]),
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              align: "right",
              formatter: _unref(formatNumber),
              label: "总计",
              prop: "companySocialSecurity",
              width: "120"
            }, null, 8, ["formatter"]),
            (companySocialFg.value)
              ? (_openBlock(), _createBlock(_component_el_table_column, {
                  key: 0,
                  label: "Details"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_table_column, {
                      width: "120",
                      align: "right",
                      formatter: _unref(formatNumber),
                      label: "单位养老保险",
                      prop: "companyEndowment"
                    }, null, 8, ["formatter"]),
                    _createVNode(_component_el_table_column, {
                      width: "120",
                      align: "right",
                      formatter: _unref(formatNumber),
                      label: "单位医疗保险",
                      prop: "companyMedical"
                    }, null, 8, ["formatter"]),
                    _createVNode(_component_el_table_column, {
                      width: "120",
                      align: "right",
                      formatter: _unref(formatNumber),
                      label: "单位工伤保险",
                      prop: "companyInjury"
                    }, null, 8, ["formatter"]),
                    _createVNode(_component_el_table_column, {
                      width: "120",
                      align: "right",
                      formatter: _unref(formatNumber),
                      label: "单位生育保险",
                      prop: "companyMaternity"
                    }, null, 8, ["formatter"]),
                    _createVNode(_component_el_table_column, {
                      width: "120",
                      align: "right",
                      formatter: _unref(formatNumber),
                      label: "单位失业保险",
                      prop: "companyUnemployment"
                    }, null, 8, ["formatter"]),
                    _createVNode(_component_el_table_column, {
                      width: "120",
                      align: "right",
                      formatter: _unref(formatNumber),
                      label: "单位公积金",
                      prop: "companyHousing"
                    }, null, 8, ["formatter"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["basicSearchConfig", "basicApi"]),
    _createVNode(_component_el_dialog, {
      modelValue: exportCostFg.value,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((exportCostFg).value = $event)),
      title: "导出成本列表"
    }, {
      default: _withCtx(() => [
        (exportCostFg.value)
          ? (_openBlock(), _createBlock(_component_FlexibleForm, _normalizeProps(_mergeProps({ key: 0 }, {
          searchConfig: searchConfig.value,
          submitText: '导出'
        })), null, 16))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})